import "./swiper-bundle.esm.js";
import { t as ResponsiveSwiper } from "./ResponsiveSwiper.js";
//#region frontend/entrypoints/sf-index-custom1.js
function initIndexCustom1Swipers() {
	const rankingContainer = document.querySelector(".swiper.p-index-custom1__ranking");
	if (rankingContainer) new ResponsiveSwiper(rankingContainer, "(max-width: 768px)", {
		loop: false,
		speed: 500,
		slidesPerView: 1.5,
		spaceBetween: 10,
		observer: true,
		observeParents: true,
		pagination: {
			el: rankingContainer.querySelector(".p-index-custom1__ranking-pagination"),
			clickable: true
		},
		navigation: {
			nextEl: rankingContainer.querySelector(".p-index-custom1__ranking-navigation.swiper-button-next"),
			prevEl: rankingContainer.querySelector(".p-index-custom1__ranking-navigation.swiper-button-prev"),
			addIcons: false
		},
		breakpoints: { 481: {
			slidesPerView: 2.2,
			spaceBetween: 20
		} }
	});
	const featureContainer = document.querySelector(".swiper.p-index-custom1__feature");
	if (featureContainer) {
		const slideCount = featureContainer.querySelectorAll(".swiper-slide").length;
		new ResponsiveSwiper(featureContainer, "(max-width: 640px)", {
			loop: slideCount > 1,
			loopedSlides: slideCount,
			spaceBetween: 20,
			centeredSlides: true,
			speed: 500,
			slidesPerView: 1,
			observer: true,
			observeParents: true,
			pagination: {
				el: featureContainer.querySelector(".p-index-custom1__feature-pagination"),
				clickable: true
			},
			navigation: {
				nextEl: featureContainer.querySelector(".p-index-custom1__feature-navigation.swiper-button-next"),
				prevEl: featureContainer.querySelector(".p-index-custom1__feature-navigation.swiper-button-prev"),
				addIcons: false
			}
		});
	}
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initIndexCustom1Swipers);
else initIndexCustom1Swipers();
//#endregion
